import { ArrowRightIcon, Button } from '@farol-ds/react'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import { GA4ClickEvent } from '@jusbrasil-web/shared-ga4-events'
import { JUSIA_ALLOWED_ORIGINS, URL_CHAT_JUSIA } from '@jusbrasil-web/shared-jusia/core'

export interface ExploreWithJusButtonProps {
  title: string
  clusterId: string
}

export function ExploreWithJusButton(props: ExploreWithJusButtonProps) {
  const { title, clusterId } = props

  const { sendGA4Event } = useGA4Dispatcher()

  const onButtonClick = () => {
    sendGA4Event(
      new GA4ClickEvent({
        componentClass: 'landing_header_hero',
        componentName: 'cta',
        resourceId: clusterId,
        selectedOption: 'explore_jusia',
      })
    )
  }

  const getURLChatJusia = () => {
    const question = `No acervo de julgados do Jusbrasil existem precedentes que defendem a tese de que ${title}?`
    return `${URL_CHAT_JUSIA}?origin=${
      JUSIA_ALLOWED_ORIGINS.THESIS_EXPLORE_WITH_JUS
    }&q=${encodeURIComponent(question)}&send`
  }

  return (
    <Button
      kind="primary"
      size="md"
      rightIcon={<ArrowRightIcon />}
      onClick={onButtonClick}
      data-testid="explore-with-jus-ia-button"
      asChild
    >
      <a href={getURLChatJusia()}>Explorar tema com o Jus IA</a>
    </Button>
  )
}
